import { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { browser } from '@atlassian/temp-helper';

const xsrfTokenRequestDecorator = (config: AxiosRequestConfig): InternalAxiosRequestConfig<any> => {
  if (config.method !== 'get') {
    // @ts-ignore
    config.headers['ATL-XSRF-Token'] = browser.getLocalStorageItem('xsrf-token');
  }

  return config as InternalAxiosRequestConfig<any>;
};

export default xsrfTokenRequestDecorator;
